<template>
  <div class="col-sm-5 col-12 app-border-right pr-md-4">
    <h6 class="font-weight-bold description-header mt-2">Top Countries</h6>

    <div
      v-for="(country,index) in countries"
      :key="country.name"
      class="pt- d-flex flex-nowrap justify-content-between align-items-center"
    >
      <div class="w-50" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
        <img class="mr-2" :src="getImg(country.name)" alt="logo" height="auto" width="20" />
        {{country.name}}
      </div>

      <div class="progress progress-sm flex-grow-2 mr-4" style="width: 55%">
        <div
          :class="bgColor(index)"
          class="progress-bar"
          :style="{width: country.percentage + '%'}"
        ></div>
      </div>

      <div>{{country.percentage + '%'}}</div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    countries: {
      type: Array,
      require: true,
    },
  },

  methods: {
    getImg(country) {
      const isoCode = country.split("-")[1];
      if (isoCode.length > 0) {
        return `https://cdn.jsdelivr.net/gh/hjnilsson/country-flags@latest/svg/${isoCode.toLowerCase()}.svg`;
      }
      return require("@/assets/logo.svg");
    },

    bgColor(index) {
      return [
        "bg-info",
        "bg-success",
        "bg-danger",
        "bg-warning",
        "bg-secondary",
        "bg-default",
      ][index];
    },
  },
};
</script>

<style scoped>
/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .app-border-top {
    border-top: 1px solid #dee2e6 !important;
  }
}

/* Small Devices, Tablets */
/* @media only screen and (min-width : 768px) {
.app-right {
    border-right: 1px solid #dee2e6 !important;
}
} */

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .app-border-right {
    border-right: 1px solid #dee2e6 !important;
  }
}

/* Large Devices, Wide Screens */
/* @media only screen and (min-width : 1200px) {
.app-right {
    border-right: 1px solid #dee2e6 !important;
}
} */
</style>